import { render } from "./index.vue?vue&type=template&id=0a9c90a7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0a9c90a7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9c90a7"],['__file',"src/views/MyAccount/MyCard/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a9c90a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a9c90a7', __exports__)) {
    console.log('reload')
    api.reload('0a9c90a7', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0a9c90a7&scoped=true", () => {
    console.log('re-render')
    api.rerender('0a9c90a7', render)
  })

}


export default __exports__